<template>
<v-card class="">
  <div class="video-responsive" v-if="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'">
    <iframe :src="videoIframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" autoplay></iframe>
  </div>
  <div class="" v-else>
    <router-link class="nolink" :to="`/admin/projects/${project.id}`">
      <v-hover>
        <template v-slot:default="{ hover }">
      <v-img :aspect-ratio="16/9" :src="project.thumbnail">
        <v-row class="lightbox white--text pa-2 fill-height">
          <v-fade-transition>
            <v-overlay :absolute="true" :value="true" :opacity="0.6" v-if="hover">
              <v-btn color="primary" >
                <v-icon small>fa-play</v-icon>
              </v-btn>
            </v-overlay>
          </v-fade-transition>
        </v-row>
      </v-img>
    </template>
      </v-hover>
    </router-link>
  </div>

  <v-card-actions class="grey lighten-3">
    <v-spacer></v-spacer>
    <span class="pull-left mr-2 pt-1 font-weight-bold grey--text text--darken-2">Visible</span>
    <div>
      <v-switch color="green" hide-details class="mt-0" inset dense :input-value="project.visible_on_profile" :disabled="true"></v-switch>
    </div>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  props: ['project'],
  name: "",
  data: () => ({

  }),
  created() {

  },
  computed: {
    videoIframe() {
      return this.$helpers.iframeFromUrl(this.project.url)
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
}
.video-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}
</style>
